<template>
    <login></login>
</template>

<script>
import Login from "./Login.vue"

export default {
    name: "Home",
    components: {
        Login
    }
}
</script>
